import {CSSProperties, FC} from 'react';


export interface IIconPlaceholderNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPlaceholderNissan: FC<IIconPlaceholderNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M19.962 9.258A8.025 8.025 0 0 0 15.44 2.78a7.977 7.977 0 0 0-7.863.558 8.087 8.087 0 0 0-3.539 5.92 8.003 8.003 0 0 0 2.315 6.449l4.988 5.014a.94.94 0 0 0 1.337 0l4.969-5.014a8.003 8.003 0 0 0 2.315-6.449Zm-3.633 5.118L12 18.719l-4.33-4.343a6.14 6.14 0 0 1-1.76-4.93 6.207 6.207 0 0 1 2.72-4.56 6.073 6.073 0 0 1 6.74 0 6.206 6.206 0 0 1 2.72 4.542 6.14 6.14 0 0 1-1.76 4.948ZM12 5.83a4.242 4.242 0 0 0-4.235 4.248A4.242 4.242 0 0 0 12 14.33a4.242 4.242 0 0 0 4.235-4.25A4.251 4.251 0 0 0 12 5.831Zm0 6.609a2.357 2.357 0 0 1-2.353-2.36A2.357 2.357 0 0 1 12 7.718c1.3 0 2.353 1.057 2.353 2.36A2.357 2.357 0 0 1 12 12.44Z" clipRule="evenodd" />
        </svg>
    );
};
